<template>
  <div>
    <vxe-table
      align="center"
      border
      resizable
      show-overflow
      ref="xTable"
      min-height="214"
      :data="tableData1"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @edit-actived="editActivedEvent">
      <vxe-column type="checkbox" width="50"></vxe-column>
      <vxe-column type="seq" width="55"></vxe-column>
      <vxe-column field="total" title="技术研发总人数" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-input v-model="row.total" min="0" type="integer"></vxe-input>
        </template>
      </vxe-column>
      <vxe-colgroup title="现有技术研发人才数量">
        <vxe-colgroup title="博士">
          <vxe-column field="doctorTotal" title="总量" :edit-render="{}">
            <template #edit="{ row }">
              <vxe-input v-model="row.doctorTotal" min="0" type="integer"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column width="85" field="doctor" title="40周岁以下数量" :edit-render="{}">
            <template #edit="{ row }">
              <vxe-input v-model="row.doctor" min="0" type="integer"></vxe-input>
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-column field="master" title="硕士" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.master" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="bachelor" title="本科" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.bachelor" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="juniorCollege" title="专科及以下" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.juniorCollege" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-colgroup title="现有技术研发人才职称数量">
        <vxe-column field="seniorEngineer" title="正高级工程师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.seniorEngineer" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="higherEngineer" title="高级工程师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.higherEngineer" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="engineer" title="工程师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.engineer" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="assistantEngineer" title="助理工程师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.assistantEngineer" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="seniorTechnician" title="高级技师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.seniorTechnician" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="technician" title="技师" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.technician" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="seniorArtisan" title="高级技工" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.seniorArtisan" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-colgroup title="校企合作情况">
        <vxe-column field="cooperativeUniversity" title="合作高校数量" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.cooperativeUniversity" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="intro" title="合作情况简介" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.intro" type="text"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
    </vxe-table>
    <vxe-toolbar>
      <template #buttons>
        <!-- <vxe-button @click="insertEvent()">新增</vxe-button> -->
        <!-- <vxe-button @click="$refs.xTable.removeCheckboxRow()">删除选中</vxe-button> -->
      </template>
    </vxe-toolbar>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'surveItem1',
  components: {},
  data() {
    return {
      tableData1: [{}],
    };
  },

  created() {},
  mounted() {
    this.$nextTick(() => {
      this.updateRoleList();
    });
  },

  methods: {
    moment,
    resetEvent() {},
    insertEvent() {
      const $table = this.$refs.xTable;
      const record = {};
      $table.insert(record);
    },
    updateRoleList() {
      const $table = this.$refs.xTable;
      // 获取表格中的全量数据
      const { fullData } = $table.getTableData();
     
    },
    roleChangeEvent({ row }) {
      this.updateRoleList();
    },
    editActivedEvent({ row }) {
      // 激活编辑时检查剩余选项是否可选择
      this.updateRoleList();
    },
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
